import lazyApiClient from './apiClient';

const authenticatedRequest = async ({
  ...fetchArgs
}) => {
  const apiClient = await lazyApiClient();
  await apiClient.authenticate();
  return apiClient.fetch({
    ...fetchArgs,
  });
};

export default authenticatedRequest;
